export default __webpack_public_path__ + "static/Rectangle4386-ccd0f87013fc9afa2223115740da9085.png";